export const DONO = 1;
export const GERENTE = 2;
export const CORRETOR = 3;
export const ESPECIALISTA = 4;
export const LIDER = 5;
// Fator lógico para pegar o usuário do parceiro
export const PARCEIRO = 9999;
export const MASTER = 99999;



// WEBPACK FOOTER //
// ./src/constants/funcionarioCargo.js